/* eslint-disable */ 
import React, { Component } from "react";
import Highcharts from "highcharts";
import sizeMe from "react-sizeme";

Highcharts.setOptions({
  colors: [
    "#E46C0A",
    "#7F7F7F",
    "#BFBFBF",
    "#95B3D7",
    "#D99694",
    "#FDEADA",
    "#CB2326",
    "#6AF9C4"
  ]
});

class Chart extends Component {
  componentDidMount() {
    this.chart = new Highcharts[this.props.type || "Chart"](
      this.chartEl,
      this.props.options
    );
  }
  componentWillReceiveProps(nextProps) {
    // console.log("Current props: ", this.props);
    // console.log("Next props: ", nextProps);
    // const { width, height } = nextProps.size;
    if (nextProps.size !== this.props.size) {
      this.chart.setSize(null);
      // this.chart.setSize(width, height);
    }
  }

  componentWillUnmount() {
    this.chart.destroy();
  }

  render() {
    return (
      <div className="container">
        <div className="pivot">
          <div className="reactPivot" ref={el => (this.chartEl = el)} />
        </div>
      </div>
    );
  }
}

export default sizeMe({ monitorHeight: true })(Chart);

// export default Chart;



// WEBPACK FOOTER //
// ./src/components/Chart.js